import { render, staticRenderFns } from "./create-packet.vue?vue&type=template&id=023e5982&scoped=true&"
import script from "./create-packet.vue?vue&type=script&lang=js&"
export * from "./create-packet.vue?vue&type=script&lang=js&"
import style0 from "./create-packet.vue?vue&type=style&index=0&id=023e5982&scoped=true&lang=scss&"
import style1 from "./create-packet.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023e5982",
  null
  
)

component.options.__file = "create-packet.vue"
export default component.exports